export const hotelTypeOptions = [
  {
    id: 0,
    name: 'Отель',
  },
  {
    id: 1,
    name: 'Апартаменты',
  },
  {
    id: 3,
    name: 'Санаторий',
  },
  {
    id: 2,
    name: 'Вилла',
  },
  {
    id: 4,
    name: 'Пансионат',
  },
  {
    id: 5,
    name: 'База отдыха',
  },
  {
    id: 6,
    name: 'Гостевой дом',
  },
  {
    id: 8,
    name: 'Хостел',
  },
];

export default hotelTypeOptions;
